import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  results: [],
  catalogResults: [],
  otherEntityResults: [],
  sort: [{_score: {order: 'desc'}}],
  _source: {},
  from: 0,
  size: 50,
  pageNumber: 1,
  query: {},
  facets: {},
  catalogFacets: {},
  pragyaResponseId: {},
  libraryList: [],
  publicLibraryList: [],
  privateLibraryList: [],
  terms: '',
  indexList: {},
  libraryPositionMapping: {},
  semester: 'Fall 2018',
  selectedSemesters: [],
  termCode: '201880',
  department: '',
  subject: '',
  division: '',
  instructor: '',
  major: '',
  unit: '',
  qr: false,
  keywords: '',
  firstyear: false,
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  friday: false,
  classTimeFrom: '',
  classTimeTo: '',
  lastUpdatedTime: {},
  catalogSearchTimeStamp: {},
  total: 0,
  catalogTotal: 0,
  selectedStreamUuid: {},
  selectedCourseFlags: [],
  showCatalogSearchDropDown: false,
  block: '',
  level: '',
  courseSearchFlags: {},
  shouldUpdateFacet: true,
  academicYear: '',
  semesterMap: {},
  semesterCodeMap: {},
  planningTermCode: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/advancedSearch/vuex/index.js